const sidebar_props = {
	menus : [    
	{'id': 1001, 'label': 'menu.dashboard', 'value':'/dashboard', 'materialkey':'dashboard'}
	],
	ms_menus : [    
	{'id': 1001, 'label': 'menu.report', 'value':'/report', 'materialkey':'assessment'}
	],
	collapsed : false
}

export default sidebar_props;


// WEBPACK FOOTER //
// ./src/model/AppConstants.js